import { FC } from "react";
import Image from "next/image";
import { TabComponent } from "@cs/components/composite/tab/TabComponent";
import { TeamSection } from "@cs/lib/models/team.model";
import styles from "./TeamTab.module.scss";
import { useTranslation } from "next-i18next";

export interface TeamTabProps {
  teamSections: TeamSection[]
  sectionType?: string
}

const normalize = (
  string:string
// eslint-disable-next-line no-irregular-whitespace
) => `${string.replace(/([ ])/g, "-").replace(/([​&(),])/g, "").toLocaleLowerCase()}`

const TeamTab: FC<TeamTabProps> = ({
  teamSections,
  sectionType
}) => {
  const {t} = useTranslation( sectionType ? sectionType + 's' : "about");

  const stringToTranslate = (
    sectionName:string,
    name:string,
    element: "description" | "position"
  ) => t(normalize(`team.${sectionName}.people.${name}.${element}`), "")

  return (
    <section className={styles.teamSection}>
      <TabComponent 
        tabs={teamSections.map((team, i) => ({
          
          title: t<string,string[]>(
            `${sectionType ? sectionType + "-categories" : 'peopleCategories'}`,
            {returnObjects: true}
          )[i],
          content: team.sections.map((section, i) => (
            <div key={i} className={styles.section}>
              {team.sections.length > 1 && (
                <h3 className={styles.sectionName}>
                  {t(`${sectionType ?? 'team'}.${normalize(section.sectionName)}.sectionName`)}
                </h3>
              )}
              <div className={styles.people}>
                {section.people.map((person, personIndex) => (
                  <div key={personIndex} className={styles.person}>
                    <div className={styles.image}>
                      <Image
                        src={person.image}
                        alt={`${person.name} profile pic`}
                        width={220}
                        height={220}
                        layout="responsive"
                      />
                      {
                        person.description && (
                          <p className={styles.description}>
                            {stringToTranslate(
                              section.sectionName,
                              person.name,
                              "description"
                            )}
                          </p>
                        )
                      }
                    </div>
                    <p className={styles.name}>
                      {person.name}
                    </p>
                    <p className={styles.position}>
                      {
                        person.position
                          ? t(`positions.${normalize(person.position  || '')}`)
                          : ""
                      }
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))
        }))}
      />
    </section>
  )
}

export default TeamTab